import { BaseModel } from '../core/model/modelInterface';
 import { BaseService as service } from '../sharedBase/baseService';
//import { BaseService as service } from '@ojas-enterprise/baseapp/dist/sharedBase';

export abstract class BaseService<T extends BaseModel> extends service<T> {


}
